import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { StoreService } from '@morningstar/shared/base/base-service';
import { environment } from '@morningstar/shared/environment';
import { FixedCharge } from './fixed-charge';
import { FixedChargesByCategorySelectors } from './fixed-charges-by-category.selectors';

@Injectable()
export class FixedChargesByCategoryService extends StoreService {

  constructor(protected httpClient: HttpClient,
              @Inject('API_BASE_URL') private baseHref,
              snackbar: MatSnackBar) {
    super(httpClient, baseHref, snackbar);
  }

  get(location: string) {
    return this.httpClient.get<FixedCharge[]>(this.baseHref + environment.api.dashboard.fixedCharges.category.replace('{location}', location));
  }
}
